module.exports = __webpack_public_path__ + "media/images/responsive/page_common/noimage/resort/spot_pc-c0964d5061a9dd5cddcbd3b7d0318a6d.png";